<div class="slide-3d">
      <ng-content></ng-content>
</div>
